import React from 'react';

const AwardsAndCertificates = () => {
  const awards = [
    {
      title: 'NVidia Fundamentals of Deep Learning Certificate',
      description: 'A course that covers the foundations of deep learning and neural networks using Keras.',
      date: 'Dec 2023',
    },
    {
      title: 'OpenCV TensorFlow Keras Bootcamp Certificate',
      description: 'A course that covers the basics of OpenCV, TensorFlow, and Keras for computer vision and deep learning.',
      date: 'March 2024',
    },
    {
      title: 'DU/MSU Hackathon Winner',
      description: 'A Website called SpiderByte won my team of 2 second place against teams of 4-6',
      date: 'October 2023',
    },
  ];

  return (
    <div style={styles.container}>
      {awards.map((award, index) => (
        <div key={index} style={styles.card}>
          <h3 style={styles.title}>{award.title}</h3>
          <p style={styles.description}>{award.description}</p>
          <p style={styles.date}>{award.date}</p>
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    width: '95%',
    margin: '20px auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  card: {
    backgroundColor: '#0a0a0a',
    border: '1px solid #fff',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '20px',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'center',
  },
  title: {
    fontSize: '2em',
    color: '#fff',
    marginBottom: '10px',
  },
  description: {
    fontSize: '1.2em',
    color: '#ddd',
    marginBottom: '10px',
  },
  date: {
    fontSize: '1em',
    color: '#aaa',
  },
};

export default AwardsAndCertificates;
